import {OfferEntryData} from './core/models/offerEntryData';

const offerEntryDataConst: OfferEntryData = {
    columnHeaders: [
        '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00', '24:00'],
    columnEditable: [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
    intervalTimes: [
        new Date(2000, 1, 1, 1), new Date(2000, 1, 1, 2), new Date(2000, 1, 1, 3), new Date(2000, 1, 1, 4), new Date(2000, 1, 1, 5), new Date(2000, 1, 1, 6), new Date(2000, 1, 1, 7), new Date(2000, 1, 1, 8), new Date(2000, 1, 1, 9), new Date(2000, 1, 1, 10), new Date(2000, 1, 1, 11), new Date(2000, 1, 1, 12), new Date(2000, 1, 1, 13), new Date(2000, 1, 1, 14), new Date(2000, 1, 1, 15), new Date(2000, 1, 1, 16), new Date(2000, 1, 1, 17), new Date(2000, 1, 1, 18), new Date(2000, 1, 1, 19), new Date(2000, 1, 1, 20), new Date(2000, 1, 1, 21), new Date(2000, 1, 1, 22), new Date(2000, 1, 1, 23), new Date(2000, 1, 1, 24)],
    intervalIds: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
    isOfferedToMarket: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
    level: 'REGISTRATION',
    product: 'econ-dr',
    gridRows: [
        {
            id: "0",
            name: 'Hyundai',
            aggregationlevel: 'REGISTRATION',
            deratingFactor: 0.7,
            deratingFactorEditField: 0.7,
            paymentCapPercent: 100,
            hasAlert: false,
            alertColor: '',
            alertTooltip: '',
            hasInfo: false,
            infoTooltip: '',
            stateOrder: 2,
            stateCode: "UNSUBMITTED",
            subGridRows: [],
            isVisibleOnGrid: true,
            isVisibleOnChart: true,
            chartColour: '#0085B9',
            hasManualUpdates: [],
            subExpanded: false,
            isTotalRow: false,
            isSubGrid: false,
            isSubGridAndIsVisible: false,
            bidExpanded: false,
            dataRows: [
                {
                    name: 'Customers Estimate',
                    metaDataKey: "",
                    isEditable: false,
                    showOnlyOnExpand: true,
                    isOnChart: false,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: '',
                    tooltip: 'This is the customers estimate',
                    dataValues: [6500, 8400, 7300, 7900, 7000, 6800, 7000, 10000, 15000, 15000, 15000, 15000, 15000, 15000, 15000, 14000, 20100, 17800, 16200, 16200, 22000, 24300, 25200, 22200],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: false
                },
                {
                    name: 'CBL',
                    metaDataKey: "",
                    isEditable: false,
                    showOnlyOnExpand: true,
                    isOnChart: false,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: '',
                    tooltip: 'This is the actual usage baseline',
                    dataValues: [6500, 8400, 7300, 7900, 7000, 6800, 8200, 12400, 17900, 18800, 19500, 16400, 17400, 19000, 19600, 19900, 20100, 17800, 16200, 16200, 22000, 24300, 25200, 22200],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: false
                },
                {
                    name: 'Maximum Usage',
                    metaDataKey: "",
                    isEditable: true,
                    showOnlyOnExpand: true,
                    isOnChart: true,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: 'bar',
                    tooltip: 'This is the maximum usage',
                    dataValues: [6500, 8400, 7300, 7900, 7000, 6800, 7360, 10720, 15870, 16140, 16350, 15420, 15720, 16200, 16380, 15770, 20100, 17800, 16200, 16200, 22000, 24300, 25200, 22200],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: true
                },
                {
                    name: 'Curtailment Bid',
                    metaDataKey: "",
                    isEditable: true,
                    showOnlyOnExpand: false,
                    isOnChart: false,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: '',
                    tooltip: 'This is the bid',
                    dataValues: [0, 0, 0, 0, 0, 0, 840, 1680, 2030, 2660, 3150, 980, 1680, 2800, 3220, 4130, 0, 0, 0, 0, 0, 0, 0, 0],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['', '', '', '#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: true
                }
            ]
        },
        {
            id: "1",
            name: 'Samwoo Aluminium',
            aggregationlevel: 'REGISTRATION',
            deratingFactor: 0.9,
            deratingFactorEditField: 0.7,
            paymentCapPercent: 100,
            hasAlert: false,
            alertColor: '',
            alertTooltip: '',
            hasInfo: false,
            infoTooltip: '',
            stateOrder: 2,
            stateCode: "UNSUBMITTED",
            subGridRows: [],
            isVisibleOnGrid: true,
            isVisibleOnChart: true,
            chartColour: '#D3ECD7',
            hasManualUpdates: [],
            subExpanded: false,
            isTotalRow: false,
            isSubGrid: false,
            isSubGridAndIsVisible: false,
            bidExpanded: false,
            dataRows: [
                {
                    name: 'Customers Estimate',
                    metaDataKey: "",
                    isEditable: false,
                    showOnlyOnExpand: true,
                    isOnChart: false,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: '',
                    tooltip: 'This is the customers estimate',
                    dataValues: [4500, 6400, 5300, 5900, 5000, 4800, 5000, 8000, 13000, 13000, 13000, 13000, 13000, 13000, 13000, 12000, 18100, 15800, 14200, 14200, 20000, 22300, 23200, 20200],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: false
                },
                {
                    name: 'CBL',
                    metaDataKey: "",
                    isEditable: false,
                    showOnlyOnExpand: true,
                    isOnChart: false,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: '',
                    tooltip: 'This is the actual usage baseline',
                    dataValues: [4500, 6400, 5300, 5900, 5000, 4800, 6200, 10400, 15900, 16800, 17500, 14400, 15400, 17000, 17600, 17900, 18100, 15800, 14200, 14200, 20000, 22300, 23200, 20200],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: false
                },
                {
                    name: 'Maximum Usage',
                    metaDataKey: "",
                    isEditable: true,
                    showOnlyOnExpand: true,
                    isOnChart: true,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: 'bar',
                    tooltip: 'This is the maximum usage',
                    dataValues: [4500, 6400, 5300, 5900, 5000, 4800, 5360, 8720, 13870, 14140, 14350, 13420, 13720, 14200, 14380, 13770, 18100, 15800, 14200, 14200, 20000, 22300, 23200, 20200],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: false
                },
                {
                    name: 'Curtailment Bid',
                    metaDataKey: "",
                    isEditable: true,
                    showOnlyOnExpand: false,
                    isOnChart: false,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: '',
                    tooltip: 'This is the bid',
                    dataValues: [0, 0, 0, 0, 0, 0, 0, 1480, 1830, 2460, 2950, 780, 1480, 2600, 3420, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: true
                }
            ]
        },
        {
            id: "2",
            name: 'Group X',
            aggregationlevel: 'GROUP',
            deratingFactor: 0.9,
            deratingFactorEditField: 0.7,
            paymentCapPercent: 100,
            hasAlert: false,
            alertColor: '',
            alertTooltip: '',
            hasInfo: false,
            infoTooltip: '',
            stateOrder: 2,
            stateCode: "UNSUBMITTED",
            subGridRows: ["3", "4"],
            isVisibleOnGrid: true,
            isVisibleOnChart: true,
            chartColour: '#008EAA',
            hasManualUpdates: [],
            subExpanded: false,
            isTotalRow: false,
            isSubGrid: false,
            isSubGridAndIsVisible: false,
            bidExpanded: false,
            dataRows: [
                {
                    name: 'Customers Estimate',
                    metaDataKey: "",
                    isEditable: false,
                    showOnlyOnExpand: true,
                    isOnChart: false,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: '',
                    tooltip: 'This is the customers estimate',
                    dataValues: [3180, 3120, 3070, 3200, 3350, 2800, 2800, 2800, 3350, 3340, 3300, 3300, 3100, 3220, 2500, 2500, 2500, 2500, 3200, 3300, 3300, 3300, 3120, 3120],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: false
                },
                {
                    name: 'CBL',
                    metaDataKey: "",
                    isEditable: false,
                    showOnlyOnExpand: true,
                    isOnChart: false,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: '',
                    tooltip: 'This is the actual usage baseline',
                    dataValues: [3180, 3120, 3070, 3200, 3350, 2800, 2800, 2800, 3350, 3340, 3300, 3300, 3100, 3220, 2500, 2500, 2500, 2500, 3200, 3300, 3300, 3300, 3120, 3120],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: false
                },
                {
                    name: 'Maximum Usage',
                    metaDataKey: "",
                    isEditable: true,
                    showOnlyOnExpand: true,
                    isOnChart: true,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: 'bar',
                    tooltip: 'This is the maximum usage',
                    dataValues: [3180, 3120, 3070, 3200, 3350, 3340, 3300, 3300, 3350, 3340, 3300, 3300, 3100, 3220, 3200, 3180, 3120, 3070, 3200, 3300, 3300, 3300, 3120, 3120],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: false
                },
                {
                    name: 'Curtailment Bid',
                    metaDataKey: "",
                    isEditable: true,
                    showOnlyOnExpand: false,
                    isOnChart: false,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: '',
                    tooltip: 'This is the bid',
                    dataValues: [0, 0, 0, 0, 0, 540, 500, 500, 0, 0, 0, 0, 0, 0, 700, 680, 620, 570, 0, 0, 0, 0, 0, 0],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: true
                }
            ]
        },
        {
            id: "3",
            name: 'ABC',
            aggregationlevel: 'REGISTRATION',
            deratingFactor: 0.9,
            deratingFactorEditField: 0.7,
            paymentCapPercent: 100,
            hasAlert: false,
            alertColor: '',
            alertTooltip: '',
            hasInfo: false,
            infoTooltip: '',
            stateOrder: 2,
            stateCode: "UNSUBMITTED",
            subGridRows: [],
            isVisibleOnGrid: true,
            isVisibleOnChart: false,
            chartColour: '#008EAA',
            hasManualUpdates: [],
            subExpanded: false,
            isTotalRow: false,
            isSubGrid: true,
            isSubGridAndIsVisible: false,
            bidExpanded: false,
            dataRows: [
                {
                    name: 'Customers Estimate',
                    metaDataKey: "",
                    isEditable: false,
                    showOnlyOnExpand: true,
                    isOnChart: false,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: '',
                    tooltip: 'This is the customers estimate',
                    dataValues: [1590, 1560, 1535, 1600, 1675, 290, 250, 200, 1675, 1670, 1650, 1650, 1550, 1610, 400, 400, 400, 350, 1600, 1650, 1650, 1650, 1560, 1560],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: false
                },
                {
                    name: 'CBL',
                    metaDataKey: "",
                    isEditable: false,
                    showOnlyOnExpand: true,
                    isOnChart: false,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: '',
                    tooltip: 'This is the actual usage baseline',
                    dataValues: [1590, 1560, 1535, 1600, 1675, 1380, 1400, 1450, 1675, 1670, 1650, 1650, 1550, 1610, 1200, 1190, 1160, 1185, 1600, 1650, 1650, 1650, 1560, 1560],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: false
                },
                {
                    name: 'Maximum Usage',
                    metaDataKey: "",
                    isEditable: true,
                    showOnlyOnExpand: true,
                    isOnChart: false,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: '',
                    tooltip: 'This is the maximum usage',
                    dataValues: [1590, 1560, 1535, 1600, 1675, 1670, 1650, 1650, 1675, 1670, 1650, 1650, 1550, 1610, 1600, 1590, 1560, 1535, 1600, 1650, 1650, 1650, 1560, 1560],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: false
                },
                {
                    name: 'Curtailment Bid',
                    metaDataKey: "",
                    isEditable: true,
                    showOnlyOnExpand: false,
                    isOnChart: false,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: '',
                    tooltip: 'This is the bid',
                    dataValues: [0, 0, 0, 0, 0, 290, 250, 200, 0, 0, 0, 0, 0, 0, 400, 400, 400, 350, 0, 0, 0, 0, 0, 0],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: true
                }
            ]
        },
        {
            id: "4",
            name: 'DEF',
            aggregationlevel: 'REGISTRATION',
            deratingFactor: 0.9,
            deratingFactorEditField: 0.7,
            paymentCapPercent: 100,
            hasAlert: false,
            alertColor: '',
            alertTooltip: '',
            hasInfo: false,
            infoTooltip: '',
            stateOrder: 2,
            stateCode: "UNSUBMITTED",
            subGridRows: [],
            isVisibleOnGrid: true,
            isVisibleOnChart: false,
            chartColour: '#008EAA',
            hasManualUpdates: [],
            subExpanded: false,
            isTotalRow: false,
            isSubGrid: true,
            isSubGridAndIsVisible: false,
            bidExpanded: false,
            dataRows: [
                {
                    name: 'Customers Estimate',
                    metaDataKey: "",
                    isEditable: false,
                    showOnlyOnExpand: true,
                    isOnChart: false,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: '',
                    tooltip: 'This is the customers estimate',
                    dataValues: [4500, 6400, 5300, 5900, 5000, 4800, 5000, 8000, 13000, 13000, 13000, 13000, 13000, 13000, 13000, 12000, 18100, 15800, 14200, 14200, 20000, 22300, 23200, 20200],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: false
                },
                {
                    name: 'CBL',
                    metaDataKey: "",
                    isEditable: false,
                    showOnlyOnExpand: true,
                    isOnChart: false,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: '',
                    tooltip: 'This is the actual usage baseline',
                    dataValues: [4500, 6400, 5300, 5900, 5000, 4800, 6200, 10400, 15900, 16800, 17500, 14400, 15400, 17000, 17600, 17900, 18100, 15800, 14200, 14200, 20000, 22300, 23200, 20200],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: false
                },
                {
                    name: 'Maximum Usage',
                    metaDataKey: "",
                    isEditable: true,
                    showOnlyOnExpand: true,
                    isOnChart: false,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: '',
                    tooltip: 'This is the maximum usage',
                    dataValues: [4500, 6400, 5300, 5900, 5000, 4800, 5360, 8720, 13870, 14140, 14350, 13420, 13720, 14200, 14380, 13770, 18100, 15800, 14200, 14200, 20000, 22300, 23200, 20200],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: false
                },
                {
                    name: 'Curtailment Bid',
                    metaDataKey: "",
                    isEditable: true,
                    showOnlyOnExpand: false,
                    isOnChart: false,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: '',
                    tooltip: 'This is the bid',
                    dataValues: [0, 0, 0, 0, 0, 250, 250, 300, 0, 0, 0, 0, 0, 0, 300, 280, 220, 220, 0, 0, 0, 0, 0, 0],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: true
                }
            ]
        },
        {
            id: "5",
            name: 'Portfolio X',
            aggregationlevel: 'REGISTRATION',
            deratingFactor: 0.9,
            deratingFactorEditField: 0.7,
            paymentCapPercent: 100,
            hasAlert: false,
            alertColor: '',
            alertTooltip: '',
            hasInfo: false,
            infoTooltip: '',
            stateOrder: 2,
            stateCode: "UNSUBMITTED",
            subGridRows: [],
            isVisibleOnGrid: true,
            isVisibleOnChart: true,
            chartColour: '#66B6D5',
            hasManualUpdates: [],
            subExpanded: false,
            isTotalRow: true,
            isSubGrid: false,
            isSubGridAndIsVisible: false,
            bidExpanded: false,
            dataRows: [
                {
                    name: 'Customers Estimate',
                    metaDataKey: "",
                    isEditable: false,
                    showOnlyOnExpand: true,
                    isOnChart: false,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: '',
                    tooltip: 'This is the customers estimate',
                    dataValues: [9730, 11590, 10460, 11210, 10450, 9680, 9910, 13060, 18550, 18540, 18500, 18620, 18440, 18560, 17830, 16700, 22800, 20460, 19500, 19600, 25390, 27690, 28400, 25400],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: false
                },
                {
                    name: 'CBL',
                    metaDataKey: "",
                    isEditable: false,
                    showOnlyOnExpand: true,
                    isOnChart: true,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: 'line',
                    tooltip: 'This is the actual usage baseline',
                    dataValues: [9730, 11590, 10460, 11210, 10450, 9680, 10270, 13780, 19420, 19680, 19850, 19040, 19160, 19760, 19210, 18470, 22800, 20460, 19500, 19600, 25390, 27690, 28400, 25400],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: false
                },
                {
                    name: 'Maximum Usage',
                    metaDataKey: "",
                    isEditable: true,
                    showOnlyOnExpand: false,
                    isOnChart: false,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: '',
                    tooltip: 'This is the maximum usage',
                    dataValues: [9730, 11590, 10460, 11210, 10450, 10220, 11610, 15960, 21590, 22490, 23150, 20020, 20840, 22560, 23130, 23430, 23560, 21030, 19500, 19600, 25390, 27690, 28400, 25400],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: false
                },
                {
                    name: 'Curtailment Bid',
                    metaDataKey: "",
                    isEditable: true,
                    showOnlyOnExpand: false,
                    isOnChart: false,
                    lineColour: '',
                    lineCaption: '',
                    isVisibleInGrid: true,
                    typeOnChart: '',
                    tooltip: 'This is the bid',
                    dataValues: [0, 0, 0, 0, 0, 540, 1340, 2180, 2170, 2810, 3300, 980, 1680, 2800, 3920, 4960, 760, 570, 0, 0, 0, 0, 0, 0],
                    roundedDataValues: [],
                    rowSum: 0,
                    cellColours: ['#D3ECD7', '#008EAA', '#66B6D5', '#0085B9', '#003E74', '#EA7600', '#662F98', '#B12A31', '#333333', '#EEAB1A', '#23A139'],
                    shadeColours: [],
                    fontColours: [],
                    cellTooltip: [],
                    showStatus: true
                }
            ]
        }
    ],
    sortedGridRows: [],
    sortOptions: [],
    selectedSort: null,
    additionalChartSeries: [
        {
            name: "Every 5 minutes",
            colour: 'blue',
            type: 'line',
            xData: [new Date(2000, 1, 1, 1, 0), new Date(2000, 1, 1, 1, 5), new Date(2000, 1, 1, 1, 10), new Date(2000, 1, 1, 1, 15), new Date(2000, 1, 1, 1, 20), new Date(2000, 1, 1, 1, 25), new Date(2000, 1, 1, 1, 30), new Date(2000, 1, 1, 1, 35), new Date(2000, 1, 1, 1, 40), new Date(2000, 1, 1, 1, 45), new Date(2000, 1, 1, 1, 50), new Date(2000, 1, 1, 1, 55), new Date(2000, 1, 1, 2, 0), new Date(2000, 1, 1, 2, 5), new Date(2000, 1, 1, 2, 10), new Date(2000, 1, 1, 2, 15), new Date(2000, 1, 1, 2, 20), new Date(2000, 1, 1, 2, 25), new Date(2000, 1, 1, 2, 30), new Date(2000, 1, 1, 2, 35), new Date(2000, 1, 1, 2, 40), new Date(2000, 1, 1, 2, 45), new Date(2000, 1, 1, 2, 50), new Date(2000, 1, 1, 2, 55)],
            yData: [15400, 25410, 25420, 25430, 25440, 25450, 25450, 25460, 25500, 25440, 25500, 26500, 27510, 28520, 29300, 25400, 25600, 25700, 25800, 25200, 25300, 25500, 25600, 25555]
        },
        {
            name: "Every 15 minutes",
            colour: 'red',
            type: 'line',
            xData: [new Date(2000, 1, 1, 1, 0), new Date(2000, 1, 1, 1, 15), new Date(2000, 1, 1, 1, 30), new Date(2000, 1, 1, 1, 45), new Date(2000, 1, 1, 2, 0), new Date(2000, 1, 1, 2, 15), new Date(2000, 1, 1, 2, 30), new Date(2000, 1, 1, 2, 45), new Date(2000, 1, 1, 3, 0), new Date(2000, 1, 1, 3, 15), new Date(2000, 1, 1, 3, 30), new Date(2000, 1, 1, 3, 45), new Date(2000, 1, 1, 4, 0), new Date(2000, 1, 1, 4, 15), new Date(2000, 1, 1, 4, 30), new Date(2000, 1, 1, 4, 45), new Date(2000, 1, 1, 5, 0), new Date(2000, 1, 1, 5, 15), new Date(2000, 1, 1, 5, 30), new Date(2000, 1, 1, 5, 45), new Date(2000, 1, 1, 6, 0), new Date(2000, 1, 1, 6, 15), new Date(2000, 1, 1, 6, 30), new Date(2000, 1, 1, 6, 45)],
            yData: [18500, 37510, 37520, 37530, 37540, 37550, 37550, 37560, 37600, 37540, 37600, 37600, 37610, 37620, 37400, 37500, 37700, 37800, 37900, 27230, 37500, 37700, 37800, 37955]
        }
    ],
    loadedPortfolioID: "",
    startTime: new Date(2000, 1, 1, 0, 0, 0),
    endTime: new Date(2000, 1, 1, 23, 59),
    rowHeaderContextMenu: [
        {
            typeKey: "total",
            functionKey: "manage_group",
            caption: "Manage Group",
            isSeparator: false,
            includeForAggregatedView: true,
            includeForDetailedView: false
            
        },
        {
            typeKey: "total",
            functionKey: "update_program_price",
            caption: "Update NBTP Price",
            isSeparator: false,
            includeForAggregatedView: true,
            includeForDetailedView: false
        },
        {
            typeKey: "portfolio",
            functionKey: "create_market_offer_edr",
            caption: "Create Market Offer",
            isSeparator: false,
            includeForAggregatedView: true,
            includeForDetailedView: true
        },
        {
            typeKey: "portfolio",
            functionKey: "load_cleared_offer",
            caption: "Load Cleared Offer",
            isSeparator: false,
            includeForAggregatedView: true,
            includeForDetailedView: true
        },
        {
            typeKey: "portfolio",
            functionKey: "confirm_cleared_quantity",
            caption: "Confirm Cleared Quantity",
            isSeparator: false,
            includeForAggregatedView: true,
            includeForDetailedView: true
        },
        {
            typeKey: "portfolio",
            functionKey: "no_cleared_offer",
            caption: "No Cleared Offer",
            isSeparator: false,
            includeForAggregatedView: true,
            includeForDetailedView: true
        },
        {
            typeKey: "portfolio",
            functionKey: "",
            caption: "",
            isSeparator: true,
            includeForAggregatedView: true,
            includeForDetailedView: true
        },
        {
            typeKey: "portfolio",
            functionKey: "add_reg_to_portfolio",
            caption: "Add Registration To Portfolio",
            isSeparator: false,
            includeForAggregatedView: true,
            includeForDetailedView: true
        },
        {
            typeKey: "portfolio",
            functionKey: "manage_group",
            caption: "Manage Group",
            isSeparator: false,
            includeForAggregatedView: true,
            includeForDetailedView: true
            
        },
        {
            typeKey: "portfolio",
            functionKey: "update_program_price",
            caption: "Update NBTP Price",
            isSeparator: false,
            includeForAggregatedView: true,
            includeForDetailedView: true
        },
        {
            typeKey: "group",
            functionKey: "display_contact_list",
            caption: "Display Contact List",
            isSeparator: false,
            includeForAggregatedView: false,
            includeForDetailedView: true
        },
        {
            typeKey: "group",
            functionKey: "send_notification",
            caption: "Send Notification",
            isSeparator: false,
            includeForAggregatedView: false,
            includeForDetailedView: true
        },
        {
            typeKey: "group",
            functionKey: "",
            caption: "",
            isSeparator: true,
            includeForAggregatedView: false,
            includeForDetailedView: true
        },
        {
            typeKey: "group",
            functionKey: "confirm_cleared_quantity",
            caption: "Confirm Cleared Quantity",
            isSeparator: false,
            includeForAggregatedView: true,
            includeForDetailedView: true
        },
        {
            typeKey: "group",
            functionKey: "reject_registration",
            caption: "Reject Registration",
            isSeparator: false,
            includeForAggregatedView: true,
            includeForDetailedView: true
        },
        {
            typeKey: "group",
            functionKey: "",
            caption: "",
            isSeparator: true,
            includeForAggregatedView: false,
            includeForDetailedView: true
        },
        {
            typeKey: "group",
            functionKey: "remove_registration",
            caption: "Remove Registration",
            isSeparator: false,
            includeForAggregatedView: false,
            includeForDetailedView: true
        },
        {
            typeKey: "group",
            functionKey: "remove_registration",
            caption: "XXXX Test",
            isSeparator: false,
            includeForAggregatedView: false,
            includeForDetailedView: true
        },
        {
            typeKey: "registration",
            functionKey: "display_contact_list",
            caption: "Display Contact List",
            isSeparator: false,
            includeForAggregatedView: false,
            includeForDetailedView: true
        },
        {
            typeKey: "registration",
            functionKey: "send_notification",
            caption: "Send Notification",
            isSeparator: false,
            includeForAggregatedView: false,
            includeForDetailedView: true
        },
        {
            typeKey: "registration",
            functionKey: "",
            caption: "",
            isSeparator: true,
            includeForAggregatedView: false,
            includeForDetailedView: true
        },
        {
            typeKey: "registration",
            functionKey: "confirm_cleared_quantity",
            caption: "Confirm Cleared Quantity",
            isSeparator: false,
            includeForAggregatedView: true,
            includeForDetailedView: true
        },
        {
            typeKey: "registration",
            functionKey: "reject_registration",
            caption: "Reject Registration",
            isSeparator: false,
            includeForAggregatedView: true,
            includeForDetailedView: true
        },
        {
            typeKey: "registration",
            functionKey: "",
            caption: "",
            isSeparator: true,
            includeForAggregatedView: false,
            includeForDetailedView: true
        },
        {
            typeKey: "registration",
            functionKey: "remove_registration",
            caption: "Remove Registration",
            isSeparator: false,
            includeForAggregatedView: false,
            includeForDetailedView: true
        }
    ],
            columnHeaderContextMenu:  [
                {
                    typeKey: "column_header",
                    functionKey: "set_bid_periods",
                    caption: "Set Bid Periods",
                    isSeparator: false,
                    includeForAggregatedView: false,
                    includeForDetailedView: true
                }
            ],
            cellContextMenu: [
                {
                    typeKey: "grid_cell",
                    functionKey: "set_values_default",
                    caption: "Set Values(s)",
                    isSeparator: false,
                    includeForAggregatedView: false,
                    includeForDetailedView: true
                },
                {
                    typeKey: "grid_cell",
                    functionKey: "adjust_values_default",
                    caption: "Adjust Values(s)",
                    isSeparator: false,
                    includeForAggregatedView: false,
                    includeForDetailedView: true
                }
            ]
};

export function GetData(): OfferEntryData {
    //hack to correct the totals in the dummy data - just add it up
    var offerEntryData: OfferEntryData = offerEntryDataConst;
    for (let gridRow of offerEntryData.gridRows) {
        for (let j = 0; j < 4; j++) {
            for (let i = 0; i < offerEntryData.columnHeaders.length; i++) {
                gridRow.dataRows[j].roundedDataValues.push(gridRow.dataRows[j].dataValues[i]);
            }
        }
        if (gridRow.isTotalRow) {
            for (let i = 0; i < offerEntryData.columnHeaders.length; i++) {
                for (let j = 0; j < 4; j++) {
                    let total: number = 0;
                    for (let subgridRow of offerEntryData.gridRows) {
                        if (subgridRow.isSubGrid == false && subgridRow.isTotalRow == false) {
                            total += subgridRow.dataRows[j].dataValues[i];
                        }
                    }
                    gridRow.dataRows[j].dataValues[i] = total;
                }
            }
        }
    }
    return offerEntryData;
}



// WEBPACK FOOTER //
// ./src/app/offer-entry-mock-data.ts